import { render, staticRenderFns } from "./BtnW.vue?vue&type=template&id=6b69555a"
import script from "./BtnW.vue?vue&type=script&lang=js"
export * from "./BtnW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports